<style>
    .guia {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 15mm;
        font-size: 12px;
        width: 210mm;
        height: 297mm;
        box-sizing: border-box;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 10px;
        margin-top: 5mm;
        table-layout: fixed;
    }

    thead th {
        border-bottom: 0.5mm solid #000;
        padding: 2mm;
        font-weight: bold;
    }

    tbody td {
        padding: 2mm;
        height: 6mm;
        border-bottom: 0.1mm solid #ddd;
    }



    .page-break {
        page-break-after: always;
        break-after: page;
    }


    .data-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1mm;
        align-items: flex-start;
    }

    .label {
        font-weight: bold;
        white-space: nowrap;
        margin-right: 2mm;
        flex-shrink: 0;
    }

    .value {
        text-align: right;
        flex-grow: 1;
        padding-left: 2mm;
    }

    /* Para alinear verticalmente cuando hay múltiples líneas */
    .data-row {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 2mm;
        align-items: baseline;
    }

    .header-columns {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        margin-top: 15px;
    }

    .header-left,
    .header-right {
        width: 48%;
    }

    .header-logo {
        flex: 0 0 100px;
        padding: 5px;
        border: 0.5px dashed #ccc;
    }

    .logo-image {
        max-width: 100%;
        max-height: 80px;
        object-fit: contain;
    }

    .total-value {
        text-align: right;
    }

    @media print {
        body {
            visibility: hidden;
        }

        .guia {
            visibility: visible;
            position: absolute;
            left: 0;
            top: 0;
        }

        .logo-image {
            max-height: 60px !important;
            /* Reduce tamaño para impresión */
        }


    }
</style>
<div id="guia-remision-container" class="guia">
    <div class="header">
        <div class="header-columns">

            <div class="header-logo">
                <img src="assets/icons/cortijo.png" alt="Logo Empresa" class="logo-image">
            </div>

            <div class="header-left">
                <strong>EMPRESA AVICOLA EL CORTIJO SA DE CV</strong><br>
                Casa Matriz: Aldea Germania Km 7 Carretera al Sur,<br>
                50mis después puente Germania<br>
                TEL (504) 2226-3080 FAX (504)<br>
                RTN 08019002278331<br>
                rp.legalpolloscortijo.com
            </div>

            <!-- Columna 3: Guía de Remisión -->
            <div class="header-right">
                <div class="document-title">Guía de Remisión</div>
                <div class="document-title">{{guiaData?.class?.code}}</div>
            </div>
        </div>


        <div class="header-columns">
            <!-- Columna Izquierda -->
            <div class="header-left">
                <div class="data-row">
                    <span class="label">EMISOR:</span>
                    <span class="value">5000 - CDTGU Aldea Germania<br>Km 7 carretera al Sur Tegucigalpa</span>
                </div>
                <div class="data-row">
                    <span class="label">DESTINO:</span>
                    <span class="value">5001 - CDSPS Nor-Oeste Urbano</span>
                </div>
            </div>

            <!-- Columna Derecha -->
            <div class="header-right">
                <div class="data-row">
                    <span class="label">RANGO AUTORIZADO:</span>
                    <span class="value">{{guiaData?.range[0]?.lowerLimit}}-{{guiaData?.range[0]?.upperLimit}}</span>
                </div>
                <div class="data-row">
                    <span class="label">FECHA LÍMITE DE EMISIÓN:</span>
                    <span class="value">{{guiaData?.range[0]?.dateTimeEnd | date:'dd/MM/yyyy' }}</span>
                </div>
                <div class="data-row">
                    <span class="label">CAI:</span>
                    <span class="value">{{guiaData?.range[0]?.code}}</span>
                </div>
                <!-- <div class="data-row">
                    <span class="label">DOCUMENTO ENTREGA:</span>
                    <span class="value">{{guiaData?.class?.code}}</span>
                </div>
                <div class="data-row">
                    <span class="label">Nº. PEDIDO TRASLADO:</span>
                    <span class="value">{{guiaData?.serial}}</span>
                </div> -->
                <div class="data-row">
                    <span class="label">FECHA/HORA IMPRESIÓN:</span>
                    <span class="value">{{ date | date:'dd/MM/yyyy - HH:mm:ss' }}</span>
                </div>
                <div class="data-row">
                    <span class="label">FECHA FIN TRASLADO:</span>
                    <span class="value">{{guiaData?.trip?.dateHourEndTeoric | date:'dd/MM/yyyy'}}</span>
                </div>
            </div>
        </div>
        <!-- <strong>FECHA/HORA IMPRESIÓN:</strong> {{ date | date:'dd/MM/yyyy - HH:mm:ss' }}<br>
                <strong>FECHA FIN TRASLADO:</strong>{{guiaData?.trip?.dateHourEndTeoric | date:'dd/MM/yyyy'}} -->
    </div>


    <table>
        <thead>
            <tr>
                <th>Material</th>
                <th>Descripción</th>
                <th>Almacén</th>
                <th style="text-align: right;">Unid.</th>
                <th style="text-align: right;">Lbs</th>
            </tr>
        </thead>
        <tbody>
            <!-- Recorrer los detalles de guiaData y generar las filas dinámicamente -->
            <tr *ngFor="let item of guiaData?.detail">
                <td>{{ removeLeadingZeros(item?.material?.code) }}</td>
                <td>{{ item?.material?.name }}</td>
                <td>{{ item?.warehouse?.name || '' }}</td>
                <!-- Aquí asumo que `almacen` puede no estar presente, por eso lo hago opcional -->
                <td class="total-value">{{ item.pararellQuantity | number: '1.3-3'}}</td>
                <td class="total-value">{{ item.baseQuantity | number: '1.3-3'}}</td>
            </tr>

            <!-- Filas vacías para completar -->
            <tr *ngFor="let i of filasVacias">
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <!-- Fila para el total -->
            <tr class="total-row">
                <td colspan="4">Total:</td>
                <td class="total-value">{{ totalLibras | number: '1.3-3' }}</td> <!-- Formateo con 3 decimales -->
            </tr>
        </tbody>
    </table>


    <div class="document-info">
        <div class="info-column">
            <strong>DATOS DEL TRANSPORTISTA</strong><br>
            <div class="data-row">
                <span class="label">NOMBRE:</span>
                <span class="value">{{guiaData?.user?.user_login?.username}}</span>
            </div>
            <div class="data-row">
                <span class="label">RTN:</span>
                <span class="value"></span>
            </div>
        </div>
        <div class="info-column">
            <strong>DATOS DEL CONDUCTOR</strong><br>
            <div class="data-row">
                <span class="label">MOTIVO:</span>
                <span class="value"></span>
            </div>
            <div class="data-row">
                <span class="label">PLACA:</span>
                <span class="value">{{guiaData?.vehicle[0]?.vehicle?.plate}}</span>
            </div>
            <div class="data-row">
                <span class="label">NOMBRE:</span>
                <span class="value">{{guiaData?.user?.user_login?.username}}</span>
            </div>
            <div class="data-row">
                <span class="label">PLACA 2:</span>
                <span class="value"></span>
            </div>
            <div class="data-row">
                <span class="label">PLACA 3:</span>
                <span class="value"></span>
            </div>
            <div class="data-row">
                <span class="label">IDENTIFICACIÓN:</span>
                <span class="value"></span>
            </div>
            <div class="data-row">
                <span class="label">MARCA:</span>
                <span class="value">{{guiaData?.vehicle[0]?.vehicle?.brand}}</span>
            </div>
        </div>
    </div>

    <div class="signature-section">
        <div class="signature-box">ENTREGADO POR:</div>
        <div class="signature-box">RECIBIDO POR:</div>
    </div>

    <div class="footer">
        Original: Destinatario
    </div>
</div>